export const RULE_SECTIONS = {
  DEFAULT: 'default',
} as const;
